type SubscriptionStatus = "active" | "due" | "inactive" | "frozen";

export type IUserSubscriptionPlans =
	| "freemium"
	| "trialing"
	| "superuser"
	| "advanced"
	| "enterprise"
	| "plus"
	| "premium"
	| "plus_max"
	| "api_starter"
	| "api_startup"
	| "api_enterprise";

export enum UserSubscriptionPlanEnum {
	Free = "free",
	Starter = "starter",
	Pro = "pro",
	Teams = "teams",
	Enterprise = "enterprise",
	Superuser = "superuser",
	Legacy_Freemium = "freemium",
	Legacy_Trialing = "trialing",
	Legacy_Advanced = "advanced",
	Legacy_Premium = "premium",
	Legacy_Plus = "plus",
	Legacy_PlusMax = "plus_max",
	ApiStarter = "api_starter",
	ApiStartup = "api_startup",
	ApiEnterprise = "api_enterprise",
	AppSumoTier1 = "app_sumo_tier_1",
	AppSumoTier2 = "app_sumo_tier_2",
	AppSumoTier3 = "app_sumo_tier_3",
	AppSumoTier4 = "app_sumo_tier_4"
}

export enum SubscriptionPlanStatusEnum {
	Active = "active",
	Old = "old",
	Inactive = "inactive"
}

/**User information */
export type IUser = {
	id: string;
	/**
	 * user status: active | inactive | banned
	 */
	status: string;
	email: string;
	group: UserSubscriptionPlanEnum;
	start_time: string | null;
	end_time: string | null;
	subscription: "yookassa" | "stripe" | null;
	external_auth?: boolean;
	"st-ev": any;
	/**
	 * @description name of tariff
	 */
	name: string;
	credits: {
		credits_balance: number;
		count_credits_by_sub: number;
		is_infinity: boolean;
		credits_balance_breakdowns: {
			credits_left: number;
			credits_received: number;
			credit_type_name: string;
		}[];
		expiration_date: string | null;
	};
	/**
	 * @deprecated Use credits.credits_balance instead
	 */
	credits_balance: number;
	/**
	 * @deprecated Use credits.credits_balance_breakdowns instead
	 */
	credits_balance_breakdowns: [];
	/**
	 * is limits aplyed to user
	 */
	is_limited: boolean;
	/**
	 * @description number of monthly runs limit
	 */
	total_runs: number;
	/**
	 * @description is user in trial tariff
	 */
	is_trial: boolean;

	workspace_limit: number;
	/**
	 * @description number of avalibale monthly runs
	 */
	available_runs: number;
	/**
	 * @description date when limit on runs will be updated
	 */
	become_available_at: string | null;
	/**
	 * @description date when user was banned
	 */
	banned_at?: string;
	/**
	 * @description record of next paymnts key is the future date
	 */
	next_payment?: Record<string, number>;
	/**
	 * status of user subscription, if user has a team, personal sub should be frozen
	 */
	subscription_status?: SubscriptionStatus;
	/**
	 * @description can user run is_disabled: true nodes
	 */
	can_run_disabled: boolean;
	/**
	 * @description duplicate of subscription field, used to determine method for users with
	 */
	payment_method: "yookassa" | "stripe" | null;

	/**
	 * false - new user has not completed questionnaire, true - new user completed questionnaire, null - old user
	 */
	questionnaire: boolean | null;
	/**
	 * is prompt helper avalible to user
	 */
	prompt_helper_assistant_available: boolean;
	/**
	 * is prompt assistant avalible to user
	 */
	chat_gpt_assistant_available: boolean;
	/**
	 * used for determine user location for pricing banner
	 */
	geo: string | null;
	subscription_name: string;
	/**
	 * is user plan is active (not legacy plan before credits system)
	 */
	plan_status: SubscriptionPlanStatusEnum;
	upgrade_info: {
		upgrade_ts: string;
		old_plan: string;
		new_plan: string;
		/**
		 * if user did not confirm payment, we need to show payment link to him
		 */
		confirm_payment_link: string;
	} | null;
	sub_length: "1mo" | "3mo" | "6mo" | "12mo" | null;
	/**
	 * date when subscription will be canceled (if user disabled recurrent payments)
	 */
	cancel_at: string | null;
};

export type UserOnlineInformation = Pick<
	IUser,
	"group" | "available_runs" | "become_available_at" | "banned_at"
>;
